import { GzEncryptionGeneralWebComponent } from './component/GzEncryptionGeneralWebComponent';

export { GzEncryptionGeneralWebComponent };
